var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWarning = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18440EE3-AABB-406E-8904-1E9CC20BCC5F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.-eKYC-Updated---Out-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.00.09-Scan-Vote-ID:-Error",
    transform: "translate(-120.000000, -269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Feedback",
    transform: "translate(24.000000, 269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_hi",
    transform: "translate(96.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.26875,87.6625 C110.49375,96.9125 106.21875,105 95.76875,105 L24.23125,105 C13.78125,105 9.5,96.9125 14.73125,87.6625 L50.5,21.90625 C55.70625,12.9375 64.25,12.4625 69.50625,21.90625 L105.26875,87.6625 Z",
    id: "37b7819c_16c7_4644_b4a8_2287306fbebd",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.76875,103.75 L24.23125,103.75 C17.09375,103.75 12.8375,100 12.51875,94.6375 C12.20625,100.625 16.55,105 24.23125,105 L95.76875,105 C103.45,105 107.79375,100.625 107.48125,94.6375 C107.1625,100 102.90625,103.75 95.76875,103.75 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,40 C57.5,38.6192881 58.6192881,37.5 60,37.5 C61.3807119,37.5 62.5,38.6192881 62.5,40 L62.5,75.3125 C62.5,76.6932119 61.3807119,77.8125 60,77.8125 C58.6192881,77.8125 57.5,76.6932119 57.5,75.3125 L57.5,40 Z",
    id: "74c49690_151a_4fc8_9c60_5a7a49244759",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e3e0c83d_04f8_47a6_866c_cf9ed5ce1207",
    fill: "#E60000",
    fillRule: "nonzero",
    cx: 60,
    cy: 87.43125,
    r: 3.75
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_warning.20888ac561c8d4ec1d29a0349c087501.svg";